<template>
  <div class="pages">
    <van-popup
        v-model="pshow"
        get-container="body"
        :style="{ height: '85%', width: '96%' }"
        :closeable="true"
      >
        <div class="itme-wrapper">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            详情
          </div>
          <van-cell-group class="plr20">
            <van-cell title="气瓶编号" :value="showbottleList.bottleId||'-'" />
            <van-cell title="充装介质" :value="showbottleList.gasTypeName||'-'" />
            <van-cell title="入库时间" :value="showbottleList.incomingTime||'-'" />           
            <van-cell title="登记单位" :value="showbottleList.ownerDeptName||'-'" />
            <van-cell title="制造单位" :value="showbottleList.makerDept||'-'" />
            <van-cell title="出厂编号" :value="showbottleList.leaveFactoryNo||'-'" />
            <van-cell title="自有编号" :value="showbottleList.ownerNo||'-'" />
            <van-cell title="制造年月" :value="showbottleList.makeDate||'-'" />
            <van-cell title="末检年月" :value="showbottleList.lastCheckDate||'-'" />
            <van-cell title="下检年月" :value="showbottleList.nextCheckDate||'-' " />
            <van-cell title="报废年月" :value="showbottleList.scrapDate||'-'" />
            <van-cell title="气瓶种类" :value="showbottleList.bottleType||'-'" />            
            <van-cell title="气瓶规格" :value="showbottleList.bottleModel||'-'" />
          </van-cell-group>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="pshow = false">关闭</van-button>
          </div>
        </div>
    </van-popup>
    <div class="top-tab">
      <van-pull-refresh class="bggrey history" v-model="isLoading" @refresh="onRefresh">
        <div v-if="historyList.length">
          <div class="his-wrapper" v-for="(item, index) in historyList" :key="index">
            <div class="his-items">
              <span>登记单位：</span>
              <span>{{item.ownerDeptName ||'-'}}</span>
            </div>
            <div class="his-items">
              <span>气瓶编号：</span>
              <span>{{item.bottleId ||'-'}}</span>
            </div>
            <div class="his-items">
              <span>填充介质：</span>
              <span>{{item.gasTypeName ||'-'}}</span>
            </div>
            <div class="his-items">
              <span>领用人：</span>
              <span>{{item.borrowerName ||'-'}}</span>
            </div>
            <div class="his-items">
              <span>领用时间：</span>
              <span>{{item.borrowTime ||'-'}}</span>
            </div>
            <van-button type="info" size="small" class="lsits"
              @click="getDetail(item)">详情</van-button>
          </div>
        </div>
        <div class="flex jscenter" v-else style="margin-top: 10vh;font-size: 38px;">
          暂无数据
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import {
  queryBorrowOverdue,
  queryBottleDetail
} from "@/apis/api";
import { Toast } from "vant";
export default {
  data() {
    return {
      showbottleList:{},
      pshow:false,
      updateItem:{},
      historyList: [],
      pageSize: 10,
      pageNo: 1,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
    };
  },
  mounted() {
    document.title = "气瓶领用超期";
    this.getHistoryList();
  },
  methods: {
    
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    //历史列表
    onRefresh(index) {
      this.isLoading = true;
      queryBorrowOverdue({}).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result;
        } else {
        }
      });
    },
    //历史记录详情
    getDetail(item) {
      this.showbottleList = item;
      this.pshow = true;
      this.getOutDetailList(item.bottleUid)
    },
    getOutDetailList(bottleId){
      queryBottleDetail({
				bottleId: bottleId
			}).then(res => {
				if (res.code == 200) {
          this.showbottleList = res.result;
				} else {
					this.$toast(res.message);
				}
			})
    },
    
  },
};
</script>
<style lang="less" scoped>
.pages {
  background: #f3f3f3;
  min-height: 100vh;
}
.history {
  padding: 16px;
  min-height: 90vh;
  border-radius: 6px;
  .his-wrapper {
    background: #fff;
    border-radius: 6px;
    padding: 15px;
    position: relative;
    margin-bottom: 16px;
    .his-items {
      height: 46px;
      line-height: 46px;
    }

    .audits {
      position: absolute;
      right: 40px;
      top: 70%;
      transform: translateY(-70%);
      font-size: 30px;
      color: green;
    }

    .lsits {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      height: 40px;
    }
  }
}



</style>
